/**
 * Main permanent products of the ecosystem.
 * Only these count toward the "owned products" tier
 * that selects the personalised subscription checkout URL.
 *
 * Each group is same-market SKU aliases of ONE logical product (e.g. two
 * Hotmart product IDs for the same Cocina Real offer). Groups must NEVER mix
 * different markets/languages of the "same" course (Panadería Cero ES vs.
 * Brotglück DE, Cocina Real ES vs. Clean Meals EN, etc.) — this file backs
 * ownsProductOrVariant()/hasAccess() in AuthContext, the actual content
 * access gate, and merging markets there meant a Panadería Cero buyer was
 * treated as also owning Brotglück (DE), and could be routed into/granted
 * access to the German module instead of their own. Each market variant
 * gets its own single-id group instead.
 */
export const MAIN_PRODUCT_GROUPS: { name: string; ids: string[] }[] = [
  { name: "Panadería Cero",  ids: ["7222660", "7418452"] },
  { name: "Clean Bakes",     ids: ["7456362", "8061842"] },
  { name: "Brotglück",       ids: ["7778710"] },
  { name: "Repostería Cero", ids: ["7368845", "7224807"] }, // 7224807=Repostería Premium Sin TACC
  { name: "Küchenglück",     ids: ["7778364"] },
  { name: "Clean Sweets",    ids: ["7381203"] },
  { name: "Cocina Real",     ids: ["7339562", "7368977"] },
  { name: "Clean Meals",     ids: ["7381661"] },
  { name: "Kochglück",       ids: ["7778879"] },
  { name: "GlucoPhoto",      ids: ["7330458", "7468894", "7487694"] },
  { name: "Clean Remedies",  ids: ["8073539"] },
];

/** All main product IDs flattened */
export const MAIN_PRODUCT_IDS: readonly string[] = MAIN_PRODUCT_GROUPS.flatMap((g) => g.ids);

/**
 * Count how many of the main products a user owns.
 * Duplicates (e.g. two Cocina Real variants) count as ONE product.
 */
export function countMainProducts(ownedProductIds: string[]): number {
  let count = 0;
  for (const group of MAIN_PRODUCT_GROUPS) {
    if (group.ids.some((id) => ownedProductIds.includes(id))) {
      count++;
    }
  }
  return count;
}
